import { LoginPage as SharedLoginPage } from '@shared/auth/LoginPage';
import { useI18n } from '@/context/I18nContext';

/**
 * Administration-branded login page.
 * Wraps the shared LoginPage component with the app-specific title.
 */
export function LoginPage() {
  const { t } = useI18n();
  return <SharedLoginPage title={t('nav.administration')} />;
}
